module.exports = __webpack_public_path__ + "media/images/companies/tokyo_marine_nichido_300_170-49964c7a35f0b72712cc764202dce930.png";